<template>
  <div class="music-player" :style="musicPlayerComponentStyle.musicPlayer">
    <div class="text-background" v-if="!musicPlayerComponentStyle.disableBackground">
      <img :src="currentBackgroundText" alt="" />
    </div>

    <div class="player" v-show="currentSong">
      <div class="dual-mode-box" v-if="dualMode">
        <div class="dual-mode-item" @click="setCurrentSong(song)">Wersja wokalna</div>
        <div class="dual-mode-item" @click="setCurrentSong(secondSong)">Wersja instrumentalna</div>
      </div>
      <div class="music-info"><div class="title" :style="musicPlayerComponentStyle.title" v-html="title"></div></div>
      <audio id="playerAudio" controlsList="nodownload noplaybackrate" controls crossorigin playsinline>
        <source :src="giveMeAudio(currentSong)" type="audio/ogg" />
        <source :src="giveMeAudio(currentSong)" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  </div>
</template>
<script>
// import VuePlyr from 'vue-plyr';
// import 'vue-plyr/dist/vue-plyr.css';
import Plyr from 'plyr';
export default {
  name: 'MusicPlayer',

  mounted() {
    if (this.secondSong) {
      this.dualMode = true;
    }
    const controls = ['play', 'restart', 'progress', 'current-time', 'mute', 'volume', 'settings'];
    this.player = new Plyr('#playerAudio', { controls });
  },

  props: {
    song: {
      type: String,
      default: '',
    },
    secondSong: {
      type: String,
      default: '',
    },
    backgroundText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    musicPlayerComponentStyle: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dualMode: false,
      currentSong: '',
      currentBackgroundText: '',
      currentTitle: '',
    };
  },
  methods: {
    giveMeAudio(audioFile) {
      return audioFile;
    },
    setCurrentSong(song) {
      this.currentSong = require(`@/config/PsMusicConfig/${song}`);
      document.querySelector('audio')?.load();
    },
  },

  watch: {
    song(value) {
      this.currentSong = '';
      this.currentSong = require(`@/config/PsMusicConfig/${value}`);

      document.querySelector('audio')?.load();
      // const controls = ['play', 'restart', 'progress', 'current-time', 'mute', 'volume', 'settings'];
      // this.player = new Plyr('#playerAudio', { controls });
    },
    // title(value) {
    //   // console.log('TITLE', value);
    //   this.currentTitle = '';
    //   setTimeout(() => {
    //     this.currentTitle = value;
    //   }, 10);
    // },
    // backgroundText(value) {
    //   //  console.log('background', value);
    //   this.currentBackgroundText = '';
    //   setTimeout(() => {
    //     this.currentBackgroundText = value;
    //   }, 10);
    // },
    // secondSong(value) {
    //   //  console.log('NORMALNIE SONG', value);
    //   if (value) {
    //     this.dualMode = true;
    //   } else {
    //     this.dualMode = false;
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.music-player {
  position: absolute;
  width: 68%;
  height: 100%;
  left: 26.6%;
  top: 0.7%;

  .text-background {
    position: absolute;
    overflow-y: auto;
    width: 50%;
    height: 68%;
    top: 10%;
    left: 25%;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
    // overflow-y: scroll;
  }

  .player {
    position: absolute;

    flex-direction: column;
    bottom: 5%;
    width: 90%;

    .music-info {
      width: 100%;
      display: flex;
      justify-content: center;

      .title {
        width: 41%;
        font-size: 1.5rem;
        background: #16b09c;
        font-family: Linotype;
        color: white;
        font-weight: 800;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
    }
    .dual-mode-box {
      display: flex;
      justify-content: center;
      .dual-mode-item {
        font-size: 1.2rem;
        cursor: pointer;
        padding: 1em;
        margin-bottom: 2%;
        color: white;
        background: #135fc8;
        &:hover {
          background: #1a78fa;
        }
      }
    }
  }
}
.plyr--audio .plyr__controls {
  background: #ffffff !important;
}
.plyr__menu__container {
  background: rgba(#ffffff, 1);
}
</style>
